import { CommonModule } from '@angular/common';
import { Component, input, computed, ChangeDetectionStrategy } from '@angular/core';
import { MatChipsModule } from '@angular/material/chips';
import { UntilDestroy } from '@ngneat/until-destroy';
import {
    CandidateScoreRating,
    determineCandidateScoreRatingText
} from 'src/app/shared/models/enums/candidate-score-rating.enum';

@UntilDestroy()
@Component({
    selector: 'nova-rating-name',
    templateUrl: './rating-name.component.html',
    styleUrls: ['./rating-name.component.scss'],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatChipsModule, CommonModule]
})
export class RatingNameComponent {
    readonly ratingId = input<CandidateScoreRating | undefined>();
    readonly name = input('');
    readonly showName = input(true);
    readonly compact = input(false);
    readonly text = computed(() => {
        const ratingId = this.ratingId();
        if (ratingId) {
            return determineCandidateScoreRatingText(ratingId);
        }

        return 'Low';
    });

    readonly ratingClass = computed(() => {
        const ratingId = this.ratingId();
        if (ratingId) {
            return 'rating-' + ratingId;
        }

        return 'rating-none';
    });
}
